(function () {
  if (window.__shuliStylist) return;
  window.__shuliStylist = true;

  var ICON = (document.currentScript && document.currentScript.dataset.icon) ||
    'https://cdn.shopify.com/s/files/1/0854/8810/7739/files/kalore-diamond.png';

  var PRESETS = [
    'What should I wear to an evening wedding?',
    'Which bag goes with a navy outfit?',
    'I need a gift for my mom',
    'How do I tie a silk scarf?',
    'What is a pearl neck scarf?',
    'What are your shipping & returns?'
  ];

  var RULE = "Our rule: one beautiful piece is enough. Keep the outfit simple and let a silk scarf or a pearl neck scarf frame your face, or a structured bag finish the look — soft colors, a touch of gold, and always worn with heart.";

  var OCCASIONS = [
    { re: /wedding|evening|party|dinner|date|gala|event|night|cocktail|celebrat|bar mitzvah|engagement/,
      picks: ['champagne', 'monochrome', 'ivory silk', 'polka dot', 'noir', 'rouge', 'quilted', 'two-tone', 'black tassel', 'blush tassel', 'pink chains', 'starry'],
      text: 'For an evening event, go for something that catches the light. A silk scarf in a rich or luminous tone tied softly at the neck, plus a small chain bag — elegant without trying too hard.' },
    { re: /work|office|meeting|interview|business|conference/,
      picks: ['navy', 'monochrome', 'ivory silk', 'polka dot', 'noir silk', 'taupe', 'grey', 'black tassel', 'two-tone'],
      text: 'For the office, keep it polished and calm: a structured bag that holds your day and a silk scarf in a classic tone knotted at the neck, or a pearl neck scarf for a neat, no-knot finish.' },
    { re: /casual|weekend|everyday|every day|brunch|coffee|shopping|daily|errand/,
      picks: ['blooming', 'garden', 'sail away', 'polka dot', 'paisley pearl', 'autumn', 'white top-handle', 'straw', 'mint', 'blush embroidered', 'poppy'],
      text: 'For everyday, choose pieces that feel light and happy. A printed silk scarf in your hair or on your bag strap, and a top-handle bag you can grab and go.' },
    { re: /summer|vacation|beach|holiday|spring|travel|sun|resort|trip/,
      picks: ['straw', 'garden', 'sail away', 'paisley pearl', 'water lily', 'poppy', 'blooming', 'mint', 'blue peony'],
      text: 'For warm days, think fresh colors and natural textures — a straw bag and a bright silk scarf worn as a headscarf or tied to your bag.' },
    { re: /winter|autumn|fall|cold|rain|coat/,
      picks: ['autumn street', 'paisley & leopard', 'noir & rouge', 'monochrome', 'rouge', 'starry', 'taupe', 'black tassel'],
      text: 'For cooler days, a silk scarf adds warmth and color over a coat, and a structured bag in a deep tone grounds the look.' },
    { re: /gift|present|mom|mother|mum|birthday|wife|girlfriend|sister|friend|anniversary|valentine/,
      picks: ['champagne', 'garden', 'water lily', 'polka dot', 'ivory quilted', 'blush tassel', 'blue peony', 'starry', 'blooming'],
      text: 'A silk scarf is the most beautiful gift — one size fits everyone and it lasts for years. Our pearl neck scarves come in sets of 3, so she gets a new look every day. For something extra special, pair a scarf with a bag.' }
  ];

  var COLORS = [
    { re: /\bblack\b|\bnoir\b/, own: ['noir', 'black', 'monochrome', 'polka dot'], pair: ['rouge', 'champagne', 'ivory quilted', 'pink chains', 'starry'] },
    { re: /\bwhite\b/, own: ['white', 'ivory', 'polka dot'], pair: ['navy', 'monochrome', 'black tassel', 'poppy', 'straw', 'sail away'] },
    { re: /ivory|cream|off.?white/, own: ['ivory'], pair: ['navy', 'two-tone', 'taupe', 'champagne'] },
    { re: /navy|\bblue\b|denim/, own: ['navy', 'blue peony', 'starry', 'sail away', 'water lily'], pair: ['ivory', 'champagne', 'taupe', 'two-tone', 'blush'] },
    { re: /pink|blush|rose/, own: ['pink', 'blush'], pair: ['grey', 'ivory', 'white top-handle', 'noir silk'] },
    { re: /\bred\b|rouge|burgundy|wine/, own: ['rouge', 'poppy'], pair: ['noir silk', 'ivory quilted', 'black tassel', 'champagne'] },
    { re: /beige|nude|neutral|camel|sand|khaki/, own: ['two-tone', 'taupe', 'paisley & leopard', 'champagne', 'ivory'], pair: ['navy', 'paisley pearl', 'rouge', 'two-tone', 'taupe'] },
    { re: /gr[ae]y|silver/, own: ['grey', 'monochrome'], pair: ['blush', 'pink chains', 'navy', 'ivory'] },
    { re: /green|mint|olive|sage/, own: ['mint', 'water lily', 'garden', 'blooming'], pair: ['champagne', 'ivory', 'straw'] },
    { re: /brown|chocolate|tan/, own: ['straw', 'autumn', 'paisley & leopard', 'taupe'], pair: ['ivory', 'champagne', 'blooming'] },
    { re: /gold|golden|champagne/, own: ['champagne', 'two-tone'], pair: ['noir silk', 'ivory quilted', 'black tassel'] }
  ];

  var INFO = [
    { re: /pearl|magnetic|neck ?scarf|neckerchief|satin|no.?knot/, text: 'Our <a href="/collections/pearl-neck-scarves">Pearl Neck Scarves</a> are soft satin scarves with a magnetic faux-pearl slider: fold the scarf, slide one end through the pearl and it stays neatly in place — no knots needed. Most come in sets of 3 prints, so you can switch your look every day.' },
    { re: /ship|deliver|arriv|how long|tracking|track/, text: 'Shipping is free across the continental US. Orders usually arrive within 2–7 business days, and you can follow your order from our <a href="/pages/track-order">Track Your Order</a> page.' },
    { re: /return|refund|exchange|send back/, text: 'Changed your mind? You can return unused items within 30 days. Full details are in our <a href="/policies/refund-policy">Returns &amp; Refunds</a> policy.' },
    { re: /tie|knot|how (do|to|can) i wear|ways to wear|style a scarf|wear (a|my|the) scarf/, text: 'Three easy ways with a 90 × 90 cm square:<br>• <b>Neck knot</b> — fold into a long band, wrap once and tie a small knot to the side.<br>• <b>Headscarf</b> — fold into a triangle, place over your hair and tie under the chin or at the nape.<br>• <b>On your bag</b> — fold into a thin band and wrap it around the handle for an instant update.<br>• <b>Pearl neck scarf</b> — no knot at all: slide one end through the magnetic pearl and adjust.' },
    { re: /\bsize|dimension|measure|how big|\bfit\b/, text: 'Our silk scarves are generous squares of about 90 × 90 cm (35 × 35 in). Our pearl neck scarves are smaller, made to sit neatly at the neck. Each bag lists its exact measurements in the product description.' },
    { re: /silk|fabric|material|made of|quality/, text: 'Our silk scarves are 100% mulberry silk — soft, light and naturally lustrous. Our pearl neck scarves are soft satin with a magnetic faux-pearl slider. Our bags have a smooth, structured finish with gold-tone hardware.' },
    { re: /care|wash|clean|iron/, text: 'Silk: hand wash cold with a gentle detergent or dry clean, do not wring, and iron on low with a cloth in between. Pearl neck scarves: hand wash cold, hang to dry, and keep the magnet away from cards. Bags: wipe with a soft dry cloth and store away from sunlight.' },
    { re: /contact|email|talk to|human|person|help me with my order|order status/, text: 'We would love to help — reach us any time through our <a href="/pages/contact">Contact</a> page.' },
    { re: /pay|paypal|card|checkout/, text: 'Checkout is secure, and you can pay as a guest — no account needed.' },
    { re: /who is shuli|about|shuli peles|your story|philosophy|style rule/, text: RULE }
  ];

  var KW = {"blanche-silk-scarf": "ivory silk scarf", "florence-silk-scarf": "blooming garden silk scarf", "aurelie-silk-scarf": "champagne silk scarf", "etoile-silk-scarf": "starry night silk scarf", "scarlett-silk-scarf": "rouge silk scarf", "odette-silk-scarf": "navy silk scarf", "colette-silk-scarf": "autumn street silk scarf", "riviera-silk-scarf": "sail away silk scarf", "giverny-silk-scarf": "water lily silk scarf", "rosalie-silk-scarf": "pink chains silk scarf", "simone-silk-scarf": "noir silk scarf", "carmen-silk-scarf": "noir & rouge silk scarf", "camille-silk-scarf": "blue peony silk scarf", "provence-silk-scarf": "poppy field silk scarf", "mimi-pearl-slide-scarf": "polka dot pearl neck scarf", "audrey-pearl-slide-scarf-trio": "monochrome pearl neck scarf set of 3", "josephine-pearl-slide-scarf-trio": "paisley & leopard pearl neck scarf set of 3", "elodie-pearl-slide-scarf-trio": "paisley pearl neck scarf set of 3", "fleur-pearl-slide-scarf-trio": "garden pearl neck scarf set of 3", "the-odile-bag": "ivory quilted chain bag", "the-ambrine-bag": "two-tone chain shoulder bag", "the-coralie-bag": "white top-handle bag with pompom", "the-soleira-bag": "straw top-handle bag", "the-ysaline-bag": "taupe structured satchel", "the-paquerette-bag": "mint embroidered top-handle bag", "the-rosabel-bag": "blush embroidered top-handle bag", "the-grisette-bag": "grey structured satchel", "the-nina-bag": "black tassel satchel", "the-bellamie-bag": "blush tassel satchel"};

  var products = null;
  function loadProducts() {
    if (products) return Promise.resolve(products);
    return fetch('/products.json?limit=250').then(function (r) { return r.json(); }).then(function (d) {
      products = (d.products || []).map(function (p) {
        var img = p.images && p.images[0] ? p.images[0].src : '';
        return {
          title: p.title, handle: p.handle, type: (p.product_type || (/pearl/.test(p.handle) ? 'pearl scarf' : /silk/.test(p.handle) ? 'silk scarf' : /bag/.test(p.handle) ? 'bag' : '')).toLowerCase(),
          key: (p.title + ' ' + (p.product_type || '') + ' ' + (KW[p.handle] || '') + ' ' + (Array.isArray(p.tags) ? p.tags.join(' ') : (p.tags || ''))).toLowerCase(),
          price: parseFloat(p.variants && p.variants[0] ? p.variants[0].price : 0),
          img: img ? img.replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2') : ''
        };
      });
      return products;
    }).catch(function () { products = []; return products; });
  }

  function pick(list, keys) {
    var out = [];
    keys.forEach(function (k) {
      list.forEach(function (p) { if (p.key.indexOf(k) > -1 && out.indexOf(p) < 0) out.push(p); });
    });
    return out;
  }

  function answer(q) {
    var t = q.toLowerCase();
    return loadProducts().then(function (all) {
      var wantPearl = /pearl|magnetic|neck ?scarf|neckerchief|satin|no.?knot/.test(t);
      var wantScarf = wantPearl || /scar(f|ves)|silk|headscarf/.test(t);
      var wantBag = /\bbag|handbag|purse|tote|satchel|clutch/.test(t);
      var pool = all.filter(function (p) {
        if (wantPearl && !wantBag) return p.type.indexOf('pearl') > -1;
        if (wantScarf && !wantBag) return p.type.indexOf('scarf') > -1;
        if (wantBag && !wantScarf) return p.type.indexOf('bag') > -1;
        return true;
      });
      var m = t.match(/(under|less than|below|up to|max|budget)\s*\$?\s*(\d+)/);
      if (m) pool = pool.filter(function (p) { return p.price <= parseFloat(m[2]); });

      var lines = [], keys = [];
      var info = INFO.filter(function (i) { return i.re.test(t); });
      if (info.length && info[0].text.indexOf('Three easy ways') === 0) info = [info[0]];
      var occ = OCCASIONS.filter(function (o) { return o.re.test(t); });
      var pairing = /go(es)? with|match|pair|with (my|a|an)|outfit|dress|wear with|suit|coat|jeans/.test(t);
      var cols = COLORS.filter(function (c) { return c.re.test(t); });

      if (info.length && !occ.length && !cols.length) {
        lines = info.slice(0, 2).map(function (i) { return i.text; });
        if (wantPearl) return { lines: lines, items: pool.slice(0, 4) };
        return { lines: lines, items: [] };
      }
      occ.forEach(function (o) { lines.push(o.text); keys = keys.concat(o.picks); });
      cols.forEach(function (c) {
        if (pairing) {
          keys = c.pair.concat(keys);
          if (!occ.length) lines.push('With that color, choose a contrast that feels soft rather than loud — here is what we would pair with it:');
        } else {
          keys = c.own.concat(keys);
          if (!occ.length) lines.push('Here are our pieces in that color family:');
        }
      });
      if (/collection|what do you (sell|have)|products|shop|new/.test(t) && !keys.length) {
        lines.push('We have three small, carefully chosen collections: <a href="/collections/silk-scarves">Silk Scarves</a> in 100% mulberry silk, new <a href="/collections/pearl-neck-scarves">Pearl Neck Scarves</a> with a magnetic pearl, and <a href="/collections/bags">Bags</a> with structured shapes and gold details. A few favorites:');
        keys = ['starry', 'garden', 'champagne', 'polka dot', 'ivory quilted', 'taupe'];
      }
      if (!keys.length && (wantScarf || wantBag || m)) {
        lines.push(m ? 'Here is what fits your budget:' : 'A few favorites:');
        keys = [''];
      }
      if (!lines.length) {
        lines.push(RULE);
        lines.push('Tell me the occasion, the colors you are wearing or who it is for, and I will suggest the perfect piece. Meanwhile, a few favorites:');
        keys = ['starry', 'garden', 'two-tone', 'champagne', 'polka dot', 'white top-handle'];
      }
      info.forEach(function (i) { if (lines.indexOf(i.text) < 0) lines.push(i.text); });
      var picked = pick(pool, keys);
      if (!wantScarf && !wantBag) {
        var sc = picked.filter(function (p) { return p.type.indexOf('scarf') > -1 && p.type.indexOf('pearl') < 0; }), pr = picked.filter(function (p) { return p.type.indexOf('pearl') > -1; }), bg = picked.filter(function (p) { return p.type.indexOf('bag') > -1; }), mix = [];
        if (!pr.length && sc.length) pr = all.filter(function (p) { return p.type.indexOf('pearl') > -1; }).slice(0, 1);
        for (var k = 0; k < 4; k++) { if (sc[k]) mix.push(sc[k]); if (pr[k]) mix.push(pr[k]); if (bg[k]) mix.push(bg[k]); }
        picked = mix;
      }
      if (wantScarf && !wantPearl && !wantBag && keys.length) {
        var sc2 = picked.filter(function (p) { return p.type.indexOf('pearl') < 0; }), pr2 = picked.filter(function (p) { return p.type.indexOf('pearl') > -1; });
        if (!pr2.length) pr2 = all.filter(function (p) { return p.type.indexOf('pearl') > -1; }).slice(0, 1);
        picked = sc2.slice(0, 3).concat(pr2.slice(0, 1)).concat(sc2.slice(3));
      }
      var items = picked.slice(0, 4);
      if (!items.length && pool.length && keys.length) items = pool.slice(0, 4);
      return { lines: lines, items: items };
    });
  }

  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function build() {
    var overlay = el('div', 'ss-overlay');
    var panel = el('aside', 'ss-panel');
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', "Savaine Stylist");
    panel.innerHTML =
      '<div class="ss-head"><h2><img src="' + ICON + '" alt="">Savaine Stylist</h2><button class="ss-close" aria-label="Close">×</button></div>' +
      '<div class="ss-body"><button type="button" class="ss-back" hidden>← Back to all questions</button><p class="ss-intro">Ask me what to wear, which piece suits an occasion, or what goes with what. I’m the Savaine stylist, here to help you find the piece that makes your look.</p><ul class="ss-chips"></ul><div class="ss-log"></div></div>' +
      '<div class="ss-foot"><form class="ss-form"><input type="text" placeholder="What are you looking for?" aria-label="Your question"><button type="submit" aria-label="Send">→</button></form><p class="ss-note">Style suggestions based on our collection.</p></div>';
    document.body.appendChild(overlay);
    document.body.appendChild(panel);

    var chips = panel.querySelector('.ss-chips'), log = panel.querySelector('.ss-log'), body = panel.querySelector('.ss-body');
    var back = panel.querySelector('.ss-back'), intro = panel.querySelector('.ss-intro');
    back.addEventListener('click', function () {
      log.innerHTML = ''; chips.style.display = ''; intro.style.display = ''; back.hidden = true; body.scrollTop = 0;
    });
    PRESETS.forEach(function (p) {
      var li = el('li'), b = el('button', null, esc(p));
      b.type = 'button';
      b.addEventListener('click', function () { ask(p); });
      li.appendChild(b); chips.appendChild(li);
    });

    function ask(q) {
      q = (q || '').trim(); if (!q) return;
      chips.style.display = 'none'; intro.style.display = 'none'; back.hidden = false;
      log.appendChild(el('div', 'ss-msg ss-user', '<span>' + esc(q) + '</span>'));
      var typing = el('div', 'ss-msg ss-bot ss-typing', 'Thinking…');
      log.appendChild(typing); body.scrollTop = body.scrollHeight;
      answer(q).then(function (a) {
        setTimeout(function () {
          typing.remove();
          var box = el('div', 'ss-msg ss-bot');
          a.lines.forEach(function (l) { box.appendChild(el('p', null, l)); });
          if (a.items.length) {
            var g = el('div', 'ss-cards');
            a.items.forEach(function (p) {
              g.appendChild(el('a', 'ss-card', '<img loading="lazy" src="' + esc(p.img) + '" alt="' + esc(p.title) + '"><b>' + esc(p.title.split(' — ')[0]) + '</b><i>$' + p.price.toFixed(2) + '</i>')).href = '/products/' + p.handle;
            });
            box.appendChild(g);
          }
          log.appendChild(box);
          box.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }, 450);
      });
    }

    panel.querySelector('.ss-form').addEventListener('submit', function (e) {
      e.preventDefault(); var i = this.querySelector('input'); ask(i.value); i.value = '';
    });
    function open() { overlay.classList.add('ss-open'); panel.classList.add('ss-open'); loadProducts(); setTimeout(function () { panel.querySelector('input').focus({ preventScroll: true }); }, 300); }
    function close() { overlay.classList.remove('ss-open'); panel.classList.remove('ss-open'); }
    overlay.addEventListener('click', close);
    panel.querySelector('.ss-close').addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    return open;
  }

  function init() {
    var icons = document.querySelector('.header__icons');
    if (!icons || icons.querySelector('.ss-btn')) return;
    var open = build();
    var btn = el('button', 'ss-btn', '<img src="' + ICON + '" alt="">');
    btn.type = 'button';
    btn.setAttribute('aria-label', "Ask Savaine Stylist");
    btn.title = "Savaine Stylist";
    btn.addEventListener('click', open);
    icons.insertBefore(btn, icons.firstElementChild);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
